import { APP_BASE_HREF } from '@angular/common';
import { Component, Input, Self, Optional, Inject } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { InputBaseComponent } from '../inputbase/inputbase.component';

@Component({
  selector: 'lebara-input',
  templateUrl: './textinput.component.html',
  styleUrls: ['../inputbase/inputbase.component.scss', './textinput.component.scss']
})
export class TextinputComponent extends InputBaseComponent implements ControlValueAccessor {
  public val: string;

  @Input('icon') icon: string;
  @Input('placeholder') pholder: string;
  @Input('maxlength') maxlength: string;

  constructor(@Self() @Optional() me: NgControl,
      @Inject(APP_BASE_HREF) private baseUrl: string,
      private transSvc: TranslateService  ) {
    super(me);
    if (me) {
      me.valueAccessor = this;
    }
  }

  public get placeholder(): string {
    if (!this.pholder || !this.pholder.length) {
      return this.transSvc.instant(this.placeHolderName);
    }
    return this.pholder;
  }

  public get placeHolderName(): string {
    return `${this.formControlName}_placeholder`.replace(':', '.');
  }

  public get isEmpty(): boolean {
    return !this.val || !this.val.length;
  }

  public get iconPath(): string {
    return `${this.baseUrl}/clientApp/dist/client-app/assets/images/${this.icon}.svg`;
  }

  public onValueChange(event: Event): void {
    this.value = (event.target as any).value;
  }

  public writeValue(value: any): void {
    this.val = value;
  }

  public set value(val: string) {
    // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }
}
